import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICardGroupResponse } from '../models/cardgroup.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets an individual card group
 * 
 * @param {string} groupId the card group id
 * @param {string} customerId the customer id
 * @param {string} partnerId the partner id
 * 
 * @returns {Promise} the api response - interface ICardGroupResponse
 */
const GetCardGroupIndividual = async (groupId?: string, customerId?: string, partnerId?: string): Promise<ICardGroupResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/card-group/${groupId}`,  {
      params: {
        wpId: userId,
        customerId: customerId,
        partnerId: partnerId,
        cardGroupID: groupId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting card group data');
    throw(error);
  }
}

export default GetCardGroupIndividual;